// extracted by mini-css-extract-plugin
module.exports = {"featuredWorkContainer":"HomePage_featuredWorkContainer__GQxrv","homeSection":"HomePage_homeSection___81U0","homeMainTitle":"HomePage_homeMainTitle__lR6Qc"};